/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component, PureComponent } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';

import { Text, Tooltip } from '../uiold';
import { themeColors } from '../uiold/Constants';
import isMouseDown from './isMouseDown';
import TagItem from '../VendorPlacement/TagItem';
import Popover from './Popover';

import { VendorSummaryWithMarkets } from '../../types/shared/Vendor';
import { Tag } from '../../types/shared/Tag';

type OuterCellProps = {
  text?: string;
  colIndex: number;
  rowIndex: number;
  cornerCell?: boolean;
  eastCursor?: boolean;
  onPress?: (
    colIndex: number,
    rowIndex: number,
    mouseEvent?: MouseEvent | undefined,
  ) => void;
  style?: StyleSet;
};

type Props = {
  onRemove: () => void;
  hasCursor: boolean;
  tags?: Array<Tag> | null | undefined;
  isSelected: boolean;
  openAssignModal?: () => void;
  openWaitlistModal?: () => void;
  vendor?: VendorSummaryWithMarkets;
  onFocus: (
    colIndex: number,
    rowIndex: number,
    mouseEvent?: MouseEvent | undefined,
    keyboardEvent?: FocusEvent | KeyboardEvent | undefined,
  ) => void;
  colIndex: number;
  rowIndex: number;
  singleColumn?: boolean;
  firstSpot?: boolean;
  lastSpot?: boolean;
  lastDate?: boolean;
  style?: StyleSet;
  canEdit?: boolean | null | undefined;
};

class Cell extends Component<Props> {
  _ref = React.createRef<View>();
  _disableFocusEventHandler = false;

  componentDidMount() {
    this._checkFocus(false, this.props.hasCursor);
  }

  componentDidUpdate(oldProps: Props) {
    this._checkFocus(oldProps.hasCursor, this.props.hasCursor);
  }

  shouldComponentUpdate(nextProps: Props) {
    if (
      nextProps.vendor === this.props.vendor &&
      nextProps.hasCursor === this.props.hasCursor &&
      nextProps.isSelected === this.props.isSelected
    ) {
      return false;
    }

    return true;
  }

  _checkFocus(oldHasCursor: boolean, newHasCursor: boolean) {
    if (oldHasCursor === false && newHasCursor === true) {
      let node = this._ref.current;
      this._disableFocusEventHandler = true;
      node && node.focus();
      this._disableFocusEventHandler = false;
    }
  }

  render() {
    let {
      tags,
      vendor,
      onFocus,
      colIndex,
      rowIndex,
      isSelected,
      hasCursor,
      singleColumn,
      firstSpot,
      lastDate,
      lastSpot,
      onRemove,
      openAssignModal,
      openWaitlistModal,
      style,
      canEdit,
      ...otherProps
    } = this.props;
    let cellStyle = [
      styles.cell,
      isSelected && styles.selectedCell,
      hasCursor && styles.cursorCell,
      style,
    ];
    let tagList: Array<React.ReactElement> = [];
    let position: {
      top?: number;
      right?: number;
      bottom?: number;
      left?: number;
    } = {};
    if (lastDate && firstSpot) {
      position.bottom = 0;
      position.left = 0;
    } else if (lastDate || singleColumn || lastSpot) {
      position.top = -3;
      position.left = 0;
    } else {
      position.right = 0;
      position.bottom = 0;
    }

    if (vendor && vendor.tags && tags) {
      for (let tag of tags || []) {
        if (vendor && vendor.tags) {
          vendor.tags.forEach((item) => {
            if (tag.id === item) {
              tagList.push(<TagItem key={tag.id} tag={tag} />);
            }
          });
        }
      }
    }

    return (
      <View
        accessible={true}
        style={[cellStyle, hasCursor && { zIndex: 1 }]}
        focusable={true}
        onFocus={(event) => {
          // We don't want to fire the focus event if:
          // (1) the focus is caused by a click
          // (2) the focus is caused by componentDidUpdate
          if (isMouseDown() || this._disableFocusEventHandler) {
            return;
          }
          // TODO: Confirm if this fourth param is a valid keyboardEvent
          onFocus(colIndex, rowIndex, undefined, event.nativeEvent);
        }}
        onClick={(event) => {
          onFocus(colIndex, rowIndex, event.nativeEvent);
        }}
        ref={this._ref}
        {...otherProps}
      >
        <Tooltip title={vendor && vendor.name ? vendor.name : ''}>
          <Text numberOfLines={1} style={styles.vendorText}>
            {vendor && vendor.name}
          </Text>
        </Tooltip>
        <View style={styles.flexRow}>{!!vendor && vendor.tags && tagList}</View>
        {hasCursor && canEdit && (
          <View style={[styles.popoverContainer, { ...position }]}>
            <Popover
              onRemove={onRemove}
              openAssignModal={openAssignModal}
              openWaitlistModal={openWaitlistModal}
              isEmpty={!vendor}
              singleColumn={singleColumn}
              firstSpot={firstSpot}
              lastSpot={lastSpot}
              lastDate={lastDate}
            />
          </View>
        )}
      </View>
    );
  }
}

export class OuterCell extends PureComponent<OuterCellProps> {
  render() {
    let {
      text,
      colIndex,
      rowIndex,
      onPress,
      eastCursor,
      cornerCell,
      style,
    } = this.props;

    return !cornerCell ? (
      <TouchableOpacity
        accessible={true}
        style={[
          styles.cell,
          style,
          { cursor: eastCursor ? 'e-resize' : 's-resize' } as any,
        ]}
        onPress={(event: any) => {
          // TODO: Confirm if this actually passes the mouseEvent (need ctrlKey)
          onPress?.(colIndex, rowIndex, event);
        }}
      >
        <Text style={styles.tableHeader}>{text || ''}</Text>
      </TouchableOpacity>
    ) : (
      <View style={[styles.cell, style, { cursor: 'no-drop' } as any]} />
    );
  }
}

const cellPadding = 10;
const cursorPadding = cellPadding - 1;
let styles = StyleSheet.create({
  flexRow: { flexDirection: 'row' },
  cell: {
    width: 150,
    height: 50,
    borderWidth: 1,
    userSelect: 'none',
    justifyContent: 'center',
    padding: cellPadding,
    backgroundColor: themeColors.white,
    borderColor: themeColors.grey,
  },
  tableHeader: { textAlign: 'center' },
  vendorText: { fontWeight: '500' },
  selectedCell: {
    backgroundColor: themeColors.backgroundBlue,
  },
  popoverContainer: {
    position: 'absolute',
    zIndex: 1,
    width: 0,
    height: 0,
  },
  cursorCell: {
    outlineWidth: 1,
    outlineStyle: 'solid',
    outlineColor: themeColors.blue,
    borderWidth: 1,
    borderColor: themeColors.blue,
    padding: cursorPadding,
  },
});

export default Cell;
